import { createFileRoute } from '@tanstack/react-router';

import AuthContainer from '@/components/layout/AuthContainer';
import Onboarding from '@/modules/authentication/pages/Onboarding';

export const Route = createFileRoute('/_authenticated/onboarding/')({
  head: () => ({
    meta: [{ title: 'Onboarding' }],
  }),
  component: () => (
    <AuthContainer>
      <Onboarding />
    </AuthContainer>
  ),
});
